import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSearch,
  faPlus,
  faTimes,
  faFilePdf,
  faPencil,
  faEye,
} from '@fortawesome/pro-light-svg-icons';
import { faMoneyCheckAlt } from '@fortawesome/pro-solid-svg-icons';
import {
  faDoNotEnter,
  faUserCircle,
  faCaretCircleRight,
  faTrash,
  faPrint,
  faChevronUp,
  faChevronDown,
  faCircleNotch,
} from '@fortawesome/pro-duotone-svg-icons';
import {} from '@fortawesome/pro-regular-svg-icons';

const iconLibrary = () =>
  library.add(
    faDoNotEnter,
    faUserCircle,
    faCaretCircleRight,
    faTrash,
    faPlus,
    faTimes,
    faSearch,
    faFilePdf,
    faPencil,
    faEye,
    faMoneyCheckAlt,
    faTrash,
    faPrint,
    faChevronUp,
    faChevronDown,
    faCircleNotch,
  );

export default iconLibrary;
